import PropTypes from 'prop-types';

import { Heading } from '@cof/plastic-components';
import { withText } from '../../text/textStore';
import { SectionHeading, ModalParagraphDivider, ModalParagraph } from './TermsAndConditionsModalView';

// @ts-expect-error TS7031: Binding element 'text' implicitly has an 'any' type.
const OfferTermsAndConditionsModalView = ({ Text: text }) => {
    return (
        <div data-qa-id="terms-and-conditions-modal-content">
            <Heading level="2" textAlign="left" data-qa-id="main-header" data-qm-allow>
                {text({ path: 'Heading' })}
            </Heading>
            <SectionHeading data-qa-id="how-to-claim-header" data-qm-allow>
                {text({ path: 'Section1.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="how-to-claim-paragraph" data-qm-allow>
                {text({ path: 'Section1.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="how-claim-work-header" data-qm-allow>
                {text({ path: 'Section2.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="how-claim-work-paragraph" data-qm-allow>
                {text({ path: 'Section2.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="when-to-claim-header" data-qm-allow>
                {text({ path: 'Section3.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="when-to-claim-paragraph" data-qm-allow>
                {text({ path: 'Section3.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
        </div>
    );
};

OfferTermsAndConditionsModalView.propTypes = {
    Text: PropTypes.func.isRequired
};

export default withText('TermsAndConditionsModalView.OfferText')(OfferTermsAndConditionsModalView);
